import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ShoppingCart } from 'lucide-react';
import { Button } from './Button';
import { motion, AnimatePresence } from 'framer-motion';
import { Helmet } from 'react-helmet';
export function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setIsOpen(false);
  }, [location]);
  const navLinks = [{
    name: 'How it Works',
    path: '/how-it-works'
  }, {
    name: 'Features',
    path: '/features'
  }, {
    name: 'Integrations',
    path: '/integrations'
  }, {
    name: 'Pricing',
    path: '/pricing'
  }];
  return <>
      <Helmet data-id="element-70">
        <meta name="google-site-verification" content="63rhCFFy-n6zoZjGqiZFV_ClR9iSLQvFPN5BGqKoCMg" data-id="element-71" />
      </Helmet>
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white/90 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-72">
        <div className="container mx-auto px-4 md:px-6" data-id="element-73">
          <div className="flex items-center justify-between" data-id="element-74">
            <Link to="/" className="flex items-center gap-2 group" data-id="element-75">
              <div className="bg-[#6366F1] p-2 rounded-lg group-hover:scale-110 transition-transform duration-200" data-id="element-76">
                <ShoppingCart className="h-6 w-6 text-white" data-id="element-77" />
              </div>
              <span className="text-xl font-bold text-gray-900" data-id="element-78">
                Cart Tracker
              </span>
            </Link>

            {/* Desktop Nav */}
            <nav className="hidden md:flex items-center gap-8" data-id="element-79">
              {navLinks.map(link => <Link key={link.path} to={link.path} className={`text-sm font-medium transition-colors hover:text-[#6366F1] ${location.pathname === link.path ? 'text-[#6366F1]' : 'text-gray-600'}`} data-id="element-80">
                  {link.name}
                </Link>)}
            </nav>

            {/* Desktop CTA */}
            <div className="hidden md:flex items-center gap-4" data-id="element-81">
              <Button variant="primary" className="py-2 px-4 text-sm" data-id="element-82">
                Install Free
              </Button>
            </div>

            {/* Mobile Menu Button */}
            <button className="md:hidden p-2 text-gray-600" onClick={() => setIsOpen(!isOpen)} aria-label="Toggle menu" data-id="element-83">
              {isOpen ? <X data-id="element-84" /> : <Menu data-id="element-85" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        <AnimatePresence data-id="element-86">
          {isOpen && <motion.div initial={{
          opacity: 0,
          height: 0
        }} animate={{
          opacity: 1,
          height: 'auto'
        }} exit={{
          opacity: 0,
          height: 0
        }} className="md:hidden bg-white border-b border-gray-100 overflow-hidden" data-id="element-87">
              <div className="container mx-auto px-4 py-6 flex flex-col gap-4" data-id="element-88">
                {navLinks.map(link => <Link key={link.path} to={link.path} className="text-base font-medium text-gray-900 py-2 border-b border-gray-50" data-id="element-89">
                    {link.name}
                  </Link>)}
                <div className="flex flex-col gap-3 mt-4" data-id="element-90">
                  <Button variant="primary" className="w-full" data-id="element-91">
                    Install Free
                  </Button>
                </div>
              </div>
            </motion.div>}
        </AnimatePresence>
      </header>
    </>;
}